import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	minimize: {
		id: 'luna.video-player-modal.content.header.minimize',
		defaultMessage: 'Minimize',
		description: 'Tooltip for minimizing a modal',
	},
	dock: {
		id: 'luna.video-player-modal.content.header.dock',
		defaultMessage: 'Dock to bottom',
		description: 'Tooltip for docking modal to the bottom in a smaller view',
	},
	expand: {
		id: 'luna.video-player-modal.content.header.expand',
		defaultMessage: 'Expand',
		description: 'Tooltip for expanding a modal',
	},
	close: {
		id: 'luna.video-player-modal.content.header.close',
		defaultMessage: 'Close',
		description: 'Tooltip for closing a modal',
	},
});
